import { uuidGen } from '@/utils/utils';

export const SESSION_ID_KEY = 'current_session_id';

class SessionService {
  private static instance: SessionService;
  private currentSessionId: string | null = null;

  private constructor() {
    // Private constructor to enforce singleton pattern
    this.currentSessionId = localStorage.getItem(SESSION_ID_KEY);
  }

  public static getInstance(): SessionService {
    if (!SessionService.instance) {
      SessionService.instance = new SessionService();
    }
    return SessionService.instance;
  }

  public startSession(): string {
    if (this.currentSessionId) {
      // End existing session before starting new one
      this.endSession();
    }
    const sessionId = uuidGen();
    this.currentSessionId = sessionId;
    localStorage.setItem(SESSION_ID_KEY, sessionId);
    return sessionId;
  }

  public endSession(): void {
    this.currentSessionId = null;
    localStorage.removeItem(SESSION_ID_KEY);
  }

  public getSessionId(): string | null {
    return this.currentSessionId;
  }
}

export const sessionService = SessionService.getInstance();
